export function colorValidator(val: string) {
  return /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(val);
}

export function logoFileValidator(data: {
  config: {
    logo?: {
      enabled?: boolean;
      file_path?: string;
    };
  };
}) {
  return (
    !data.config.logo?.enabled ||
    (data.config.logo?.enabled && data.config.logo.file_path)
  );
}
